import {
  ABTestRecommendation,
  RecommendationSettingKey,
  SolveABTestConfig,
  WinnerMetric,
} from 'src/services/agent-ab-test/types';

const VALID_SETTING_KEYS = new Set<RecommendationSettingKey>([
  'winner_metric',
  'end_condition_type',
  'duration_days',
  'sample_count',
]);

export const isValidRecommendation = (
  rec: unknown,
): rec is ABTestRecommendation => {
  if (typeof rec !== 'object' || rec === null) {
    return false;
  }
  const obj = rec as Record<string, unknown>;
  return (
    typeof obj.setting_key === 'string' &&
    VALID_SETTING_KEYS.has(obj.setting_key as RecommendationSettingKey) &&
    typeof obj.title === 'string' &&
    typeof obj.description === 'string' &&
    obj.setting_value !== undefined
  );
};

export const isRecommendationApplied = (
  rec: ABTestRecommendation,
  config: SolveABTestConfig,
): boolean => {
  switch (rec.setting_key) {
    case 'winner_metric': {
      const metric = rec.setting_value as WinnerMetric;
      if (!metric?.metric_id) {
        return false;
      }
      return (config.winner_metrics ?? []).some(
        m => m.metric_id === metric.metric_id,
      );
    }
    case 'end_condition_type':
      return config.end_condition?.condition_type === rec.setting_value;
    case 'duration_days': {
      if (config.end_condition?.condition_type !== 'fixed_duration') {
        return false;
      }
      if (!config.start_datetime || !config.end_condition?.end_datetime) {
        return false;
      }
      const start = new Date(config.start_datetime).getTime();
      const end = new Date(config.end_condition.end_datetime).getTime();
      const configDays = Math.round((end - start) / (24 * 60 * 60 * 1000));
      return configDays === (rec.setting_value as number);
    }
    case 'sample_count':
      return (
        config.end_condition?.condition_type === 'sample_count' &&
        config.end_condition?.sample_count === (rec.setting_value as number)
      );
    default:
      return false;
  }
};
